module.exports = __webpack_public_path__ + "static/media/samabbas.394c6561.jpg";